import React from 'react'
import { Link } from 'react-router-dom'
import './style.scss'

const HomeSecondTitle = (props) => {
    let lang = localStorage.getItem("lang")

    return (
        <div className='HomeSecondTitle'>
            <div>
                <h2>{props.title}</h2>
                <div className='lines'>
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                </div>
            </div>
            <Link to={props.link} className='btn purple-btn'>
                {lang === "en" ? <i className='fa fa-angle-right'></i> : <i className='fa fa-angle-left'></i>}
            </Link>
        </div>
    )
}

export default HomeSecondTitle
